// @ts-strict-ignore
import {Injectable} from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class SimPromiseDelayService {
	private instances: {[key: string]: Instance} = {};

	constructor() {}

	/**
	 * Ensures there is a minimum delay between same calls
	 *
	 * @remarks
	 *
	 *
	 * @param key - unique key, for func
	 * @param func - promise, ie. Rest call
	 * @param delay - delay in ms when already running
	 * @returns promise of func
	 */
	public callWithMinimunDelay(key: string, func: () => Promise<any>, delay: number): void {
		const instance = this.getInstance(key);

		let delayOver = new Date() > instance.nextRun;
		//console.log("delayOver: " + delayOver);
		if (instance.status == "running" || !delayOver) {
			//console.log("set status: delayed");
			instance.reRunRequested = true;
			return;
		} else {
			//console.log("set status: running");
			instance.status = "running";
			instance.nextRun = new Date(new Date().getTime() + delay);
		}

		func().then(() => {
			if (instance.reRunRequested) {
				let remainingDelay = Math.max(instance.nextRun.valueOf() - new Date().valueOf(), 0);
				//console.log("$timeout: " + delay);
				setTimeout(() => {
					instance.reRunRequested = false;
					instance.nextRun = null;
					instance.status = "ready";
					this.callWithMinimunDelay(key, func, delay);
				}, remainingDelay);
			} else {
				instance.status = "ready";
			}
		});
	}

	private getInstance(key: string): Instance {
		let instance = this.instances[key];
		if (!instance) {
			instance = this.instances[key] = {
				status: "ready",
				nextRun: null,
				reRunRequested: false,
			};
		}

		return instance;
	}
}

interface Instance {
	status: "ready" | "running";
	nextRun: Date;
	reRunRequested: Boolean;
}
